import {useMutation, useQueryClient} from '@tanstack/react-query'
import {useSnackbar} from 'notistack'
import api from 'src/services/api'
import {UpdateFace} from 'src/services/api/endpoints/FacialRecognitionEndpoint'
import {QueryKeyEnum} from 'src/utilities/enums/QueryKeyEnum'
import handleErrorWithSnackbar from 'src/utilities/handleErrorWithSnackbar'

export default function useUpdateFace() {
  const {enqueueSnackbar} = useSnackbar()
  const client = useQueryClient()
  const mutation = useMutation({
    mutationKey: [QueryKeyEnum.UPDATE_FACE],
    mutationFn: async (body: UpdateFace) => {
      const formData = new FormData()
      formData.append('id', body.id.toString())

      if (body.recognitionId) formData.append('recognition_id', body.recognitionId.toString())
      if (body.listsIds) formData.append('lists_ids', JSON.stringify(body.listsIds))
      if (body.name) formData.append('name', body.name)
      if (body.images) for (const image of body.images) formData.append(`face_images`, image)
      if (body.deleteFaceImageIds?.length) formData.append(`delete_face_image_ids`, JSON.stringify(body.deleteFaceImageIds))
      return await api.facialRecognition.updateFacial(formData)
    },
    onSuccess: async () => {
      await client.invalidateQueries({queryKey: [QueryKeyEnum.FACE_DETECTIONS]})
      enqueueSnackbar('Face atualizada com sucesso', {variant: 'success'})
    },
    onError: (error) => {
      handleErrorWithSnackbar(enqueueSnackbar, error, 'Erro ao atualizar face')
    },
  })
  return mutation
}
